export default __webpack_public_path__ + "static/media/12_roomcloud.f19783a9.svg";